module.exports = __webpack_public_path__ + "static/img/img-15.2d53583.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/i/img-15.jpg
// module id = 98
// module chunks = 0